import React from "react";
import styles from './Boern.module.css'

//components
import PageHeader from "../../../PageHeader/PageHeader";
import PageInfo from "../../components/PageInfo.js";
import ContactInfo from "../../components/ContactInfo.js"
import ImageGallery from "../../components/ImageGallery.js";
import PageState from "../../components/PageState.js";


export default function Boern() {
    return(
        <PageState
            pageName="Born"
            render={({ data, sections, sectionNames }) => {

                const {Sec1, Sec2, Sec3, Sec7, Gallery, u2} = data;

                return (
                    <div>
                        <PageHeader 
                            image={data.PageHeader.imageUrl} 
                            title={data.PageHeader.title} 
                            sections={sections} 
                            description={data.PageHeader.text} 
                            sectionNames={sectionNames}/>

                        <section 
                            id={Sec1.secId}
                            className={styles.sec1}>

                            <PageInfo 
                                title={Sec1.header} 
                                image={""} 
                                description={<div dangerouslySetInnerHTML={{ __html: Sec1.text }}/>} 
                                version={"v1"}/>

                            <ContactInfo 
                                where= {Sec1.where} 
                                when={Sec1.when} 
                                who={Sec1.who} 
                                mobile={Sec1.mobile}/>
                        </section>

                        <section 
                            id={Sec2.secId}
                            className={styles.sec2}>

                            <PageInfo 
                                title={Sec2.header} 
                                image={""} 
                                description={<div dangerouslySetInnerHTML={{ __html: Sec2.text }}/>} 
                                version={"v1"}/>

                            <ContactInfo 
                                where= {Sec2.where} 
                                when={Sec2.when} 
                                who={Sec2.who} 
                                mobile={Sec2.mobile}/>
                        </section>
                        <section className={styles.gallery}>
                            <ImageGallery images={Gallery.images}/>
                        </section>
                        <section 
                            id ={Sec3.secId} 
                            className={styles.sec3}>

                            <PageInfo 
                                title={Sec3.header} 
                                description={<div dangerouslySetInnerHTML={{ __html: Sec3.text }}/>} 
                                image={""} 
                                version={"v1"}/>

                            <ContactInfo 
                                where= {Sec3.where} 
                                when={Sec3.when} 
                                who={Sec3.who} 
                                mobile={Sec3.mobile}/>
                        </section>
                        {Sec7 &&(<section 
                            id ={Sec7.secId} 
                            className={styles.sec2}>

                            <PageInfo 
                                title={Sec7.header} 
                                description={<div dangerouslySetInnerHTML={{ __html: Sec7.text }}/>} 
                                image={""} 
                                version={"v1"}/>

                            <ContactInfo 
                                where= {Sec7.where} 
                                when={Sec7.when} 
                                who={Sec7.who} 
                                mobile={Sec7.mobile}
                                email={Sec7.email}/>
                        </section>)}
                        {u2 &&(<section 
                            id ={u2.secId} 
                            className={styles.sec3}>

                            <PageInfo 
                                title={u2.header} 
                                description={<div dangerouslySetInnerHTML={{ __html: u2.text }}/>} 
                                image={""} 
                                version={"v1"}/>

                            <ContactInfo 
                                where= {u2.where} 
                                when={u2.when} 
                                who={u2.who} 
                                mobile={u2.mobile}
                                email={u2.email}/>
                        </section>)}
                    </div>
                );
            }
        }/>
    );
}